import { forwardRef, createElement } from 'react';

function IconFilterSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20.25 2a.75.75 0 01.75.75v2a.75.75 0 01-.15.45l-5.7 7.6a.75.75 0 00-.15.45v6.725a.75.75 0 01-.494.705l-4 1.454A.75.75 0 019.5 21.43v-8.163a.75.75 0 00-.168-.473L3.168 5.207A.75.75 0 013 4.734V2.75A.75.75 0 013.75 2h16.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var FilterSolid = /*#__PURE__*/forwardRef(IconFilterSolid);

export default FilterSolid;
//# sourceMappingURL=FilterSolid.js.map
